export default "<!DOCTYPE html>\n<html >\n<body>\n<div id=\"root\"></div>\n</body>\n</html>";